module.exports = __webpack_public_path__ + "static/crazy_at_work-42fa541250d21ea79a8f7540db348ce6.png";